import axios from "axios";
import store from "@/store";
import { router } from "@/router";
import { SIGN_IN_SET_REDIRECT } from "./mutation-types";

export const userService = {
  login,
  completeLogin,
  attemptMfaChallenge,
  logout,
  clearUserFromLocalStorage,
  changePassword,
  startAutomaticLogoutChecking,
  setAuthForAllAxiosRequests,
  removeAuthFromAxiosRequests
};

async function login(loginDetails) {
  return await loginOrChangePassword("/api/users/sign-in", loginDetails);
}

async function attemptMfaChallenge(message) {
  const result = await axios.post("/api/users/verify-auth", message);
  return result.data;
}

async function logout() {
  await axios.delete("/api/users/sign-in");
}

async function changePassword(passwordDetails) {
  return await loginOrChangePassword("/api/users/password", passwordDetails);
}

async function loginOrChangePassword(endpointUrl, message) {
  const result = await axios.post(endpointUrl, message);
  const data = result.data;
  return completeLogin(data);
}

function completeLogin(data) {
  if (data.token) {
    delete data.token;
    localStorage.setItem("user", JSON.stringify(data));
  }

  return data;
}

function startAutomaticLogoutChecking() {
  window.setInterval(checkWhetherLogoutRequired, 60000);
}

async function checkWhetherLogoutRequired() {
  if (store.getters.isSignedIn) {
    const tokenHasExpired = store.getters.tokenExpires.subtract(1, "minutes").isBefore();
    if (tokenHasExpired) {
      const path = router.currentRoute.path;
      store.commit(SIGN_IN_SET_REDIRECT, path);
      router.push("/sign-out");
    }
  }
}

async function clearUserFromLocalStorage() {
  localStorage.removeItem("user");
}

let interceptorFor401s;

function setAuthForAllAxiosRequests() {
  interceptorFor401s = axios.interceptors.response.use(
    response => response,
    error => {
      const urlsToIgnore = ["/api/users/password", "/api/users/sign-in", "/api/mfa/activate-registration", "/api/mfa/sign-in"];
      const sendToSignInPage =
        error &&
        error.response &&
        error.response.status == 401 &&
        error.response.config &&
        !urlsToIgnore.includes(error.response.config.url);
      if (sendToSignInPage) {
        const path = router.currentRoute.path;
        console.log(`401 interceptor: router.currentRoute.path=${path}`);
        if (path != "/sign-out") {
          store.commit(SIGN_IN_SET_REDIRECT, path);
          router.push("/sign-out");
        }
      }
      return Promise.reject(error);
    }
  );
}

function removeAuthFromAxiosRequests() {
  if (interceptorFor401s) {
    axios.interceptors.request.eject(interceptorFor401s);
  }
}
